<script setup lang="ts">
defineProps<{
  verified: boolean
}>()
</script>

<template>
  <div
    class="alert alert-danger"
    id="workExpModalMessage"
    :class="{ hidden: !verified }"
  >
    This work experience has been verified by La Trobe and cannot be edited.
  </div>

  <p>
    If you would like to request credit based on work experience and/or industry-based certifications, please attach the following documents. <b>Failure to do so will result in the application being rejected.</b>
  </p>

  <ol>
    <li>
      <p>
        If you are an employee, a certified copy of Statement of Service from your relevant employer. The Statement of Service must be written on company letterhead and include the following information:
      </p>
      <ol class="list-style-lower-alpha">
        <li>your full name</li>
        <li>whether you are/were employed on a full-time or part-time basis</li>
        <li>the hours you work per week</li>
        <li>your position title</li>
        <li>the period of employment in the position</li>
        <li>details of the duties of the position</li>
        <li>a signature from your employer</li>
      </ol>
    </li>
    <li>
      <p>
        If you are self-employed, a letter from your accountant or solicitor on their letterhead which must include the following information:
      </p>
      <ol class="list-style-lower-alpha">
        <li>your full name</li>
        <li>how long you have been continuously engaged in the business</li>
        <li>the nature of the business</li>
        <li>the signature of the accountant or solicitor</li>
      </ol>
    </li>
    <li>Accurate and up-to-date Resume/CV.</li>
    <li>Written statement outlining how you achieved all of the subject intended learning outcomes through your work experience. For subject intended learning outcomes, please check your course Handbook.</li>
  </ol>
</template>
